const CIVIL_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

function isValidDate(value: unknown): value is Date {
  return value instanceof Date && !Number.isNaN(value.getTime());
}

// Built from numeric parts at local midnight: `new Date('YYYY-MM-DD')` parses as UTC midnight
// and shows the previous day west of Greenwich. The round trip on the parts rejects a day the
// Date constructor would roll over, such as 2026-02-30 becoming 2026-03-02.
export function parseCivilDate(value: string | null | undefined): Date | null {
  if (!value || !CIVIL_DATE_PATTERN.test(value)) return null;
  const [year, month, day] = value.split('-').map(Number);
  const date = new Date(year, month - 1, day);
  if (!isValidDate(date)) return null;
  if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
    return null;
  }
  return date;
}

export function formatCivilDateToPtBR(value: string | Date | null | undefined): string {
  if (!value) return '-';
  const date = typeof value === 'string' ? parseCivilDate(value) : value;
  if (!isValidDate(date)) return '-';
  return date.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });
}
